import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpShop'

// The Deals dashboard of shop-api. The read endpoints sit under /admin/deals-dashboard (ops ones for any staff member,
// the money ones for platform admins only: a 403 there is an answer, not a failure); the CRUD ones sit next to them.
const BASE = '/admin/deals-dashboard'

// The shared shop client reads `res.data.token` on every answer and throws on a body that is literally `null` (what a
// delete may answer): the request has worked by then, but the caller would see a failure. A null body is made an empty
// object before that interceptor sees it. (An empty answer, such as a 204, is already safe and stays as it is.)
const nullSafe = {
	transformResponse: [
		data => {
			if (typeof data !== 'string' || data === '') return data
			try {
				const parsed = JSON.parse(data)

				return parsed === null ? {} : parsed
			} catch (e) {
				return data
			}
		},
	],
}

export const dealsOverview = (params = {}) => Http.get(`${BASE}/overview${serialize(params)}`)
export const dealsStores = (params = {}) => Http.get(`${BASE}/stores${serialize(params)}`)
export const dealsIntegrations = (params = {}) => Http.get(`${BASE}/integrations${serialize(params)}`)
export const dealsClicks = (params = {}) => Http.get(`${BASE}/clicks${serialize(params)}`)
export const dealsSyncRuns = (params = {}) => Http.get(`${BASE}/sync-runs${serialize(params)}`)
export const dealsLinkChecks = (params = {}) => Http.get(`${BASE}/link-checks${serialize(params)}`)
export const dealsQuality = (params = {}) => Http.get(`${BASE}/quality${serialize(params)}`)

// Money (platform admin only).
export const dealsCommissions = (params = {}) => Http.get(`${BASE}/commissions${serialize(params)}`)
export const dealsUntapped = (params = {}) => Http.get(`${BASE}/untapped${serialize(params)}`)
export const dealsRevenue = (params = {}) => Http.get(`${BASE}/revenue${serialize(params)}`)

export const commissionRateList = (params = {}) => Http.get(`/admin/commission-rates${serialize(params)}`)
export const commissionRateCreate = data => Http.post('/admin/commission-rates', data, nullSafe)
export const commissionRateUpdate = (id, data) => Http.put(`/admin/commission-rates/${id}`, data, nullSafe)
export const commissionRateDestroy = id => Http.delete(`/admin/commission-rates/${id}`, nullSafe)

export const networkTransactionList = (params = {}) => Http.get(`/admin/network-transactions${serialize(params)}`)
export const networkTransactionCreate = data => Http.post('/admin/network-transactions', data, nullSafe)
export const networkTransactionUpdate = (id, data) => Http.put(`/admin/network-transactions/${id}`, data, nullSafe)
export const networkTransactionDestroy = id => Http.delete(`/admin/network-transactions/${id}`, nullSafe)

/** The CSV goes up as multipart: the browser sets the boundary itself when the body is a FormData. */
export const networkTransactionImport = file => {
	const body = new FormData()
	body.append('file', file)

	return Http.post('/admin/network-transactions/import', body, nullSafe)
}
